module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_5-59698f54395811cb2a7196e70de3718e.jpg";